export default __webpack_public_path__ + "static/media/SectionCard_Articles.501f2a3e.jpg";